module.exports = __webpack_public_path__ + "img/planktons_restaurant.2d176e0e.jpg";